export class RegisterState {
  public loginStatus: boolean
  public userId: string
  constructor() {
    this.loginStatus = false
    this.userId = ''
  }
}

export interface IRegisterFormData {
  phone: string,
  idCard: string,
  lineId: string,
  prefix: string,
  firstname: string,
  lastname: string,
  birthdate: string,
  map: {
    lat: number,
    lon: number,
  },
  address: {
    address: string,
    country?: string,
    district?: string,
    elevation?: number,
    geocode?: string,
    postcode?: string,
    province?: string,
    road?: string,
    road_lat?: number,
    road_lon?: number,
    subdistrict?: string,
  },
}

export default RegisterState
